export enum errorRegister {
	'NAME_NONE' = 'Please input your name!',
	'PHONE_NONE' = 'Please input your phone!',
	'PHONE_NUMBER' = 'Phone not correct format!',
	'PASSWORD_INCORRECT' = 'Confirm password is incorrect',
	'PASSWORD_CONFIRM_NONE' = 'Please input confirm your password!',
	'PASSWORD_NONE' = 'Please input your password!',
	'PASSWORD_LENGTH' = 'Password over 6 chacracters',
	'EMAIL_NONE' = 'Please input your email!',
	'EMAIL_FORMAT' = 'Email not correct format!',
}
